import { takeLatest, call, put } from 'redux-saga/effects';
import { ActionType } from 'typesafe-actions';
import { loginFailure, loginSuccess, login, logout, logoutSuccess } from './slice';
import RestService, { StepXError } from 'shared/services/http-client';
import { ACCESS_TOKEN, REFRESH_TOKEN, USER_PROFILE } from 'shared/constant';
import { USER_PROFILE_TYPE } from 'shared/types';
import { showStepXToast } from 'shared/helpers/stepx-toast';  

function* loginHandler(action: ActionType<typeof login>): unknown {
  try {
    const { data } = yield call(RestService.send, {
      serviceName: 'login',
      body: action.payload
    });

    localStorage.setItem(ACCESS_TOKEN, data.accessToken || data.token);
    if (data.refreshToken) {
      localStorage.setItem(REFRESH_TOKEN, data.refreshToken);
    }

    // Save user profile to localStorage
    const userProfile: USER_PROFILE_TYPE = {
      ...data.user
    };

    localStorage.setItem(USER_PROFILE, JSON.stringify(userProfile));

    yield put(loginSuccess({ 
      profile: userProfile
    }));

    if (action.payload.callback) {
      action.payload.callback(true);
    }

    // Sử dụng debounced error toast để tránh hiện 2 lần
    showStepXToast({
      title: 'Login Success',
      description: 'Welcome to StepX, your journey begins now.',
      duration: 3000,
      position: 'top-right'
    });
  } catch (e: StepXError | Error | unknown) {

    // Sử dụng debounced error toast để tránh hiện 2 lần
    showStepXToast({
      title: 'Login Failed',
      description: 'Please check your username and password.',
      duration: 3000,
      position: 'bottom-right'
    });

    const errorCode = (e as StepXError)?.data?.code || (e as Error)?.message || 'Login failed';
    const errorForm = (e as StepXError)?.data?.errors?.fields || null;
    
    yield put(
      loginFailure({
        code: errorCode,
        form: errorForm
      })
    );

    if (action.payload.callback) {
      action.payload.callback(false);
    }
  }
}

function* logoutHandler(): unknown {
  try {
    yield call(RestService.logout);
    
    // Clear localStorage
    localStorage.removeItem(ACCESS_TOKEN);
    localStorage.removeItem(REFRESH_TOKEN);
    localStorage.removeItem(USER_PROFILE);
    
    yield put(logoutSuccess());
  } catch {
    // Even if logout fails, we should still update the state
    localStorage.removeItem(ACCESS_TOKEN);
    localStorage.removeItem(REFRESH_TOKEN);
    localStorage.removeItem(USER_PROFILE);
    yield put(logoutSuccess());
  }
}

function* userSagas() {
  yield takeLatest(login.type, loginHandler);
  yield takeLatest(logout.type, logoutHandler);
}

export default userSagas;
